import Scenarios from "../models/ScenarioModel";

const state = () => ({
  scenariosData: [],
  scenariosOrder: [],
  selectedModal: null
});
const getters = {
  getScenarios: state => state.scenariosData,
  getScenariosOrder: state => state.scenariosOrder,
  getSelectedModal: state => state.selectedModal
};
const mutations = {
  FetchedScenarios(state, scenarios) {
    state.scenariosData = scenarios.scenarios;
    state.scenariosOrder = scenarios.scenariosOrder;
  },
  SetModal(state, id) {
    state.selectedModal = id;
  }
};
const actions = {
  async fetchScenarios({ commit }) {
    const scenariosData = await Scenarios();
    commit("FetchedScenarios", scenariosData);
  },
  setScenarioModal({ commit }, id) {
    commit("SetModal", id);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
